<template>
  <div>
    <div class="md-layout input-layout">
      <div class="md-layout-item md-size-10">
        <!-- blank Div to space fields -->
      </div>
      <div class="md-layout input-layout">
        <slot name="additional-fields"/>
        <!-- Purchase Cost -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-25"
          label="Purchase Cost"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="security.purchase_cost"
        />

        <!-- Accessories -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-20"
          label="Extras"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="security.accessories_cost"
        />

        <!-- Deposit -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-25"
          label="Deposit"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="security.deposit_value"
        />

        <!-- Trade In -->
<!--        <validated-input-->
<!--          type="CURRENCY"-->
<!--          class="md-layout-item md-small-size-100 md-size-15"-->
<!--          label="Trade In"-->
<!--          prefix="$"-->
<!--          v-model="security.trade_in_value"-->
<!--        />-->


        <!-- Requested Amount -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-25"
          label="Requested Loan Amount"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="security.requested_amount"
          @keydown="handleKeyDown($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import ValidatedInput from "../../ValidatedInput/ValidatedInput";

export default {
  components: {
    ValidatedInput,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PropertyView,
  },
  props: {
    securityType: {
      type: String,
      required: true
    },
    value:{
      type: Object,
      required: true
    },
    prefixLabel: {
      type: String,
      default: '',
    },
  },
  watch: {
    'application.loan.id'() {
      // when change the application, calculate base on the value on purchase and requested
      if (this.security && this.security.purchase_cost == 0 && this.security.requested_amount != 0) {
        this.setPurchaseCost();
      } else {
        this.setRequestedAmount();
      }
    },
    'security.purchase_cost'() { this.setRequestedAmount(); },
    'security.accessories_cost'() { this.setRequestedAmount(); },
    'security.deposit_value'() { this.setRequestedAmount(); },
    'security.trade_in_value'() { this.setRequestedAmount(); },

    // security.requested_amount will act as a two way computed property but not incure side effects that a computed property would
    'security.requested_amount'() { this.setPurchaseCost(); },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),
    security: {
      get() {
        return this.application.loan.asset[this.securityType];
      },
      set(security) {
        this.$emit("input", security);
      }
    },
    application: {
      get(){
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      }
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,

    async handleKeyDown(e){
      if(e.keyCode == 9) {
        e.preventDefault();
        this.$store.dispatch('on_loan_details_requested_amount_tab_key_pressed',true);
      }
    },
    // sets security.requested_amount as a calculation of other fields similar to a computed property
    setRequestedAmount() {
      let purchase_cost = this.float(this.security.purchase_cost);
      let accessories_cost = this.float(this.security.accessories_cost);
      let deposit_value = this.float(this.security.deposit_value);
      //let trade_in_value = this.float(this.security.trade_in_value);

      this.security.requested_amount = (purchase_cost + accessories_cost - deposit_value);
    },

    // allows us to freely update requested_amount and the purchase_cost is automatically updated
    // such that the equality requested_amount = purchase_cost + accessories_cost - deposit_value - trade_in_value holds true
    setPurchaseCost() {
      let requested_amount = this.float(this.security.requested_amount);
      let accessories_cost = this.float(this.security.accessories_cost);
      let deposit_value = this.float(this.security.deposit_value);
      //let trade_in_value = this.float(this.security.trade_in_value);

      this.security.purchase_cost = requested_amount - (accessories_cost - deposit_value);
    },
  },
  created(){
    this.security.purchase_cost = this.security.purchase_cost ?? this.application.loan.requested.amount;
    if (this.security && this.security.purchase_cost == 0 && this.security.requested_amount != 0) {
      this.setPurchaseCost();
    } else {
      this.setRequestedAmount();
    }
  }
}
</script>
